import { ApiTypes, CountryIsoCode, CurrencyIsoCode, PaymentDetailsLegalEntityType } from 'shared/data/webApp/v2';

export interface ContactQueryData {
    id?: string;
    name?: string;
}

export interface EditCounterpartyPaymentDetailsPopupContentProps {
    paymentDetailsId?: string | null;
    paymentDetails?: ApiTypes['ApiAmaxPayPaymentDetailsResultCamelCased'][];
    contact?: ApiTypes['ApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased'] | null;
    contactQueryData?: ContactQueryData;
    onPaymentDetailsChanged: (paymentDetails?: ApiTypes['ApiAmaxPayPaymentDetailsResultCamelCased']) => void;
}

export interface UseInitialFormValuesParams {
    contact?: ApiTypes['ApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased'] | null;
    paymentDetailsId?: string | null;
    paymentDetails?: ApiTypes['ApiAmaxPayPaymentDetailsResultCamelCased'][];
    isConfirmationOfPayeeOnly: boolean;
}

export type FormValues = Omit<
    ApiTypes['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'],
    'legalEntity'
> & {
    isDefault: boolean;
    payeeBankCountry: CountryIsoCode;
    payerBankCountry: CountryIsoCode;
    currencyCode: CurrencyIsoCode;
    paymentMethod: string;
    legalEntity: Omit<
        ApiTypes['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased']['legalEntity'],
        'legalEntityType'
    > & {
        legalEntityType: PaymentDetailsLegalEntityType;
    };
    selectedBenificaryName: BenificaryNameVariant | null;
};

export enum BenificaryNameVariant {
    Provided = 'Provided',
    Suggested = 'Suggested',
}
